import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/learn/ai-answer-library")({
  beforeLoad: () => {
    throw redirect({ to: "/learn", replace: true });
  },
});
